import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { iAsset } from "../../../definitions/Assets"
import { post } from "../../../store/data/actions"
import AssetHeader from "../Header"
import AssetOverview from "../inspector/Overview"

const CreateAsset: FunctionComponent = () => {
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iAsset) => {
    post<iAsset>({ link: "/v1/create-asset", data }).then((asset) => {
      history.push("/assets/" + asset.url)
      store.addNotification({
        title: "Success!",
        message: "Asset successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <AssetHeader
        submitDeleteText="Delete"
        title="Create Asset"
        submitText="Create"
        handleDelete={() => {
          console.log()
        }}
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iAsset)
          })()
        }}
      />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iAsset)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <AssetOverview />
          </Route>
          <button className="d-none" type="submit">
            Submit
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default CreateAsset
